import WhyTipsi from './WhyTipsi'

export default WhyTipsi;
